import { Button, Tooltip } from "@sede-enterprise/shell-ds-react-framework";
import { Cross, InfoCircle } from "@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components";
import React from "react";
import Plot from "react-plotly.js";


const dataModifications = {
    automargin: true,
    textinfo: "none"
};

const PieChart = ({ title, helpText, data, onPieClick, selectedPieFilterType, pieFilterType, clearPieFilters }) => {
    const layout = {
        legend: {
            orientation: "h",
            itemclick: false,
            itemdoubleclick: false
        },
        margin: { t: 20, b: 20 },
        height: 250,
    };

    const dataWithModifications = {
        ...data,
        ...dataModifications
    };


    return (
        <div className="pie-chart-container">
            <div className="pie-chart-title">
                <h4>{title}</h4>
                <div className="pie-chart-actions">
                    <Tooltip overlay={<div className='tooltip-content'>Clear Chart Filters</div>}
                        placement='bottom'
                        trigger={<Button size="xsmall" iconOnly icon={<Cross />} disabled={pieFilterType !== selectedPieFilterType}
                            aria-label="clear chart filters" onClick={clearPieFilters}
                        />} />
                    <Tooltip overlay={<div className='tooltip-content'>{helpText}</div>}
                        placement='bottom'
                        trigger={<Button variant="transparent" iconOnly icon={<InfoCircle />} />} />
                </div>
            </div>
            <div className="pie-chart">
                <Plot
                    useResizeHandler={true}
                    className="full-size-chart pointer"
                    data={[dataWithModifications]}
                    layout={layout}
                    // config={config}
                    onClick={onPieClick}
                />
            </div>
        </div>

    );
};

export default PieChart;
